import { AppResourcePage } from './app-resource-base';
import {
  clientContainerManagerFactory,
  ClientLock,
  createClientView,
  getClientContainer
} from '../clients/client-ui-adaptor';
import { customElement } from 'lit/decorators.js';
import { FranchiseeClientContainerManager } from '../clients/data/franchisee-client-container';
import { goStaticURL } from '../../../webmodule-common/other/ui/resource-resolver';
import { isEmptyOrSpace } from '../../../webmodule-common/other/ui/string-helper-functions';
import { ModalViewBase } from '../../../webmodule-common/other/ui/data-entry-screen-base';
import { NullPromise } from '../../../webmodule-common/interop/types/misc';
import { createConcurrencyCheck, ResourceLocker } from '../common/resource-lock';
import { LangAppClientPage } from '../../../localization/scripts/dealer-franchisee/pages/app-client-lang';

@customElement('app-client')
export class AppClientPage extends AppResourcePage {
  cm?: FranchiseeClientContainerManager;

  async redirectPath(): NullPromise<string> {
    return '/clients';
  }

  async createModalEditor(id: string): NullPromise<ModalViewBase> {
    const container = getClientContainer(id);

    if (isEmptyOrSpace(id)) id = container.clientId;
    this.cm = clientContainerManagerFactory(container, () => !this.lock?.isLockOwner);
    await this.cm.needsClient();
    return await createClientView(this.cm);
  }

  meta() {
    return {
      title: () => LangAppClientPage.clientEditorTitle(),
      description: 'SoftTech dealer CPQ'
    };
  }

  protected createLock(id: string): ResourceLocker | undefined {
    const lockRevokedEvent = async () => {
      await this.view?.abandonAndClose(true);
      goStaticURL('/clients');
    };

    // Create concurrency check that ensures local data is loaded and compares recordVersion with server
    const concurrencyCheck = createConcurrencyCheck('CLIENT.CLIENT', id, async () => {
      await this.cm?.needsClient();
      return this.cm?.client?.recordVersion ?? '';
    });

    return new ClientLock(id, lockRevokedEvent, concurrencyCheck);
  }
}
